import React from 'react';
import {Routes, Route, Navigate, useNavigate} from 'react-router-dom';
import {Auth0Provider} from '@auth0/auth0-react';
import AuthWrapper from '../src/product/components/auth/AuthWrapper';
import {Provider} from "react-redux";
import {TASKS_LIST_ROUTE, PRIVATE_ROUTES} from "./product/business/routes/routes";
import store from "./product/business/redux";
import {ErrorComponent, NotFoundComponent} from "./product/components/errors";
import {PrivateRoutesLayout} from "./product/components/layouts";

const Auth0ProviderWithNavigate = ({children}) => {
    const navigate = useNavigate();

    const domain = 'dev-atffe9be.us.auth0.com';
    const clientId = '1wpF5b2hi7zGiOzxYIq4e4TXusir9LbW';
    const audience = 'https://dev-atffe9be.us.auth0.com/api/v2/';

    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: audience,
            }}
            onRedirectCallback={onRedirectCallback}
        >
            {children}
        </Auth0Provider>
    );
};

const App = () => {
    return (
        // <Auth0ProviderWithNavigate>
            <Provider store={store}>
                <Routes>
                    <Route
                        path="/*"
                        element={
                            <AuthWrapper>
                                <Routes>
                                    <Route path="/" element={<PrivateRoutesLayout/>}>
                                        <Route index element={<Navigate to={TASKS_LIST_ROUTE.path}/>}/>
                                        {PRIVATE_ROUTES.map(route =>
                                            <Route
                                                key={route.path}
                                                path={route.path}
                                                element={route.element}
                                            />
                                        )}
                                        <Route path="*" element={<NotFoundComponent/>}/>
                                    </Route>
                                    <Route path="*" element={<ErrorComponent/>}/>
                                </Routes>
                            </AuthWrapper>
                        }
                    />
                </Routes>
            </Provider>
        // </Auth0ProviderWithNavigate>
    );
};

export default App;
